import { Component } from "@angular/core";
import { LoadingProgressBarService } from "../../services/loading-progress-bar.service";
import { Observable } from "rxjs";

@Component({
	selector: "app-loading-progress-bar",
	templateUrl: "./loading-progress-bar.component.html",
	styleUrls: ["./loading-progress-bar.component.scss"],
})
export class LoadingProgressBarComponent {
	loading$: Observable<any>;

	constructor(private loadingProgressBarService: LoadingProgressBarService) {
		this.loading$ = loadingProgressBarService.loading$;
	}
}
